import React, { useState } from 'react';
import { Modal, Tabs, Tab, Spinner } from 'react-bootstrap';
import axios from 'axios';
import "./css/seleccionVehiculos.css";
import { Server } from "../../constants";

export const SeleccionVehiculo = ({ show, onHide, selectModelo }) => {
  const inicioAnio = 1985;
  const finalAnio = 2025;
  const anios = Array.from({ length: finalAnio - inicioAnio + 1 }, (_, i) => inicioAnio + i);

  const columnas = [];
  for (let i = 0; i < anios.length; i += 6) {
    columnas.push(anios.slice(i, i + 6));
  }

  const [selectedAnio, setSelectedAnio] = useState(null);
  const [modelosVehiculos, setModelosVehiculos] = useState([]);
  const [selectedModelo, setSelectedModelo] = useState(null);
  const [activeTab, setActiveTab] = useState("anios");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(false);

  const toggleAnio = async (anio) => {
    setSelectedAnio(anio);
    setIsLoading(true);
    await fetchModelosForAnio(anio);
    setIsLoading(false);
    setActiveTab("modelos");
  };

  const fetchModelosForAnio = async (anio) => {
    const response = await axios.get(`${Server}/api/repuestos/getRepuestosAnio/${anio}`);
    setModelosVehiculos(response.data.data);
  };

  const selectModeloHandler = (modelo) => {
    setSelectedModelo(modelo.description);
    setSelectedVehicle(modelo.vehicle);
    selectModelo({
      vehicle: modelo.vehicle,
      anio: selectedAnio,
    });

    onHide();
  };

  const reiniciarModal = () => {
    setSelectedAnio(null);
    setModelosVehiculos([]);
    setSelectedModelo(null);
    setActiveTab("anios");
    setIsLoading(false);
  };

  return (
    <Modal size='xl' show={show} onHide={onHide} className="modal-vehiculo">
      <Modal.Header className="" closeButton>
        <Modal.Title>Seleccione su Vehículo</Modal.Title>
      </Modal.Header>
      <Modal.Body className='modal-cuerpo'>
        {isLoading ? (
          <div className="carga-container mx-auto mt-5">
            <Spinner animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
            <p>Cargando modelos...</p>
          </div>
        ) : (
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            id="seleccion-tabs"
            className="mb-3"
          >
            <Tab className="tab px-5" eventKey="anios" tabClassName='tab-title' title="Años" disabled={selectedAnio}>
              <div className='seleccion-anio'>
                {columnas.map((col, colIndex) => (
                  <div key={colIndex} className='columnas-anios'>
                    {col.map((anio) => (
                      <div key={anio} unselectable="on" className={`item-seleccionado mx-3 my-2 ${selectedAnio === anio ? 'clicked' : ''}`} onClick={() => toggleAnio(anio)}>
                        {anio}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </Tab>
            <Tab className='tab' eventKey="modelos" tabClassName='tab-title' title="Modelos" disabled={!selectedAnio}>
              <h5 className='ml-4'>Año: {selectedAnio}</h5>
              <div className='seleccion-anio mt-2'>
                {modelosVehiculos.length > 0 ? (
                  modelosVehiculos.map((modelo) => (
                    <div key={modelo.vehicle} className={`modelo-seleccionado mx-3 my-2 ${selectedModelo === modelo.description ? 'clicked' : ''}`} onClick={() => selectModeloHandler(modelo)}>
                      {modelo.description}
                    </div>
                  ))
                ) : (
                  <p>Seleccione un año para ver los modelos disponibles.</p>
                )}
              </div>
            </Tab>
          </Tabs>
        )}
      </Modal.Body>
      <Modal.Footer>
        {activeTab === "modelos" && (
          <button className="boton-reinicio btn btn-primary" onClick={reiniciarModal} disabled={isLoading}>
            Regresar
          </button>
        )}
        <button className="btn btn-secondary" onClick={onHide}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SeleccionVehiculo;